import React, { useState } from "react";
import axios from "axios";
import { contactData } from "../data";
import { motion } from "framer-motion";
import { fadeIn } from "../variants";

const EmailRestAPI = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    // EmailJS service ID, template ID, and Public Key
  const serviceId = process.env.REACT_APP_SERVICE_ID;
  const templateId = process.env.REACT_APP_TEMPLATE_ID;
  const publicKey = process.env.REACT_APP_PUBLIC_KEY;


    // Create an object with EmailJS details and form data
    const data = {
      service_id: serviceId,
      template_id: templateId,
      user_id: publicKey,
      template_params: {
        from_name: name,
        from_email: email,
        from_phone: phone,
        to_name: "SALIM ARTS",
        message: message,
      },
    };

    try {
      // Send email using EmailJS REST API
      const res = await axios.post("https://api.emailjs.com/api/v1.0/email/send", data);
      console.log("Email sent successfully:", res.data);
      alert("Email sent successfully");

      // Reset form fields
      setName("");
      setEmail("");
      setPhone("");
      setMessage("");
    } catch (error) {
      console.error("Failed to send email:", error);
    }
  };

  const { title, form } = contactData;

  return (
    <section className="section lg:py-10 xl:pb-20">
      <div className="container mx-auto">
        <div className="flex flex-col xl:flex-row gap-y-16">
          {/* Heading Section */}
          <motion.div className="flex-1">
            <h2 className="h2 max-w-[490px] mb-0">{title}</h2>
          </motion.div>

          {/* Form Section */}
          <motion.div
            variants={fadeIn("left")}
            initial="hidden"
            whileInView={"show"}
            viewport={{ once: false, amount: 0.4 }}
            className="flex-1 xl:pl-[40px] flex justify-center items-center"
          >
            <form
              className="flex flex-col gap-y-10 w-full"
              onSubmit={handleSubmit}
            >
              <input
                className="border-b border-red-500 placeholder:text-[#555] italic tracking-[0.06em] outline-none pb-4"
                placeholder={form.name}
                value={name}
                onChange={(e) => setName(e.target.value)}
                type="text"
                required
              />

              <input
                className="border-b border-red-500 placeholder:text-[#555] italic tracking-[0.06em] outline-none pb-4"
                placeholder={form.phone}
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                type="number"
                required
              />

              <input
                className="border-b border-red-500 placeholder:text-[#271414] italic tracking-[0.06em] outline-none pb-4"
                placeholder={form.email}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                type="email"
                required
              />

              <input
                className="border-b border-red-500 placeholder:text-[#555] italic tracking-[0.06em] outline-none pb-4"
                placeholder={form.message}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                type="text"
                required
              />

              <button type="submit" className="btn btn-sm btn-dark self-start">
                {form.btnText}
              </button>
            </form>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default EmailRestAPI;


// import React from 'react'
// import { contactData } from '../data';
// import { motion } from 'framer-motion';
// import { fadeIn } from '../variants';


// const Contact = () => {
//   const { title, form } = contactData;
//   return (
//   <section className='section lg:py-10 xl:pb-20'>
//     <div className='container mx-auto'>
//       <div className='flex flex-col xl:flex-row gap-y-16'>
//         <motion.div 
//         // variants={fadeIn('right')} 
//         // initial='hidden' 
//         // whileInView={'show'}
//         // viewport={{once:false, amount: 0.7}}
//         className='flex-1'>
//         <h2 className='h2 max-w-[490px] mb-0'>{title}</h2>
//           {/* <div className='flex flex-col xl:flex-row gap-x-5 gap-y-16 xl:gap-y-0'>
//             {info.map((item,index)=>{
//               const {title, subtitle,subtitle2, address, phone, email, link }= item;
//               return (
//                 <div key={index}>
//                   <div className='font-primary uppercase font-medium text-xl mb-3'>{title}</div>
//                   <div className='mb-6 text-[#333] leading-[187%] tracking-[0.02em]'>{subtitle}</div>
//                   <div className='mb-6 text-[#333] leading-[187%] tracking-[0.02em]'>{subtitle2}</div>
//                   <div className='flex flex-col gap-y-3 mb-8'>
//                     <div className='flex items-centre gap-[10px]'>
//                       <div>{address.icon}</div>
//                       <div className='font-medium'>{address.name}</div>
//                     </div>

//                     <div className='flex items-centre gap-[10px]'>
//                       <div>{phone.icon}</div>
//                       <div className='font-medium' >{phone.number}</div>
//                     </div>

//                     <div className='flex items-centre gap-[10px]'>
//                       <div>{email.icon}</div>
//                       <div className='font-medium'>{email.address}</div>
//                     </div>
//                     <a className='font-medium border-b border-red-500 pb-[5px]' href='https://g.co/kgs/GQ1CYmC'>
//                       {link}
//                     </a>
//                   </div>
//                 </div>
//               );
//             })}
//           </div> */}
//         </motion.div>
//         {/* form */}
//         <motion.div 
//         variants={fadeIn('left')} 
//         initial='hidden' 
//         whileInView={'show'}
//         viewport={{once:false, amount: 0.4}}
//         className='flex-1 xl:pl-[40px] flex justify-center items-center'>
//           <form 
//           action='mailto:bussiness@salimartssignage.com' 
//           encType='text/plain'
//           method='post'
//           className='flex flex-col gap-y-10 w-full'
//           onSubmit={(e)=>{
//             e.preventDefault();
//             alert("Thank you for your message! Please write your query from your email inbox");
//             e.target.submit();
//           }}
//           >
//             <input className='border-b border-red-500 placeholder:text-[#555] italic tracking-[0.06em] outline-none pb-4' placeholder={form.name}
//             value={form.name}
//             type='text' required/>

//             <input className='border-b border-red-500 placeholder:text-[#555] italic tracking-[0.06em] outline-none pb-4' placeholder={form.phone} 
//             value={form.phone}
//             type='number' required/>

//             <input className='border-b border-red-500 placeholder:text-[#271414] italic tracking-[0.06em] outline-none pb-4' placeholder={form.email} 
//             value={form.email}
//             type='email' required/>

//             <input className='border-b border-red-500 placeholder:text-[#555] italic tracking-[0.06em] outline-none pb-4' placeholder={form.message} 
//             value={form.message}
//             type='text' required/>

//             <button type='submit'
//             className='btn btn-sm btn-dark self-start'>{form.btnText}</button>
//           </form>
//         </motion.div>
//       </div>
//     </div>
//   </section>);
//   };

// export default Contact;
